module.exports = __webpack_public_path__ + "img/glass-wine.061ae7b0.svg";